import React from 'react';

export default function MenuItemsPhotoneo(): JSX.Element {
    return <></>;
}
